// Purchase types ("type d'achat") of netlinking-sourcing. A type is identified by its id,
// never by its name: the default types can be renamed without any effect here.
// Same rules as dashboard-spa's composables/sourcing/purchaseTypes.js (the two fronts share no code).

// Fixed ids of the default types, declared in netlinking-sourcing (PurchaseType.java) and
// duplicated in campaign-manager and dashboard-spa.
export const SPONSORED_TYPE_ID = "cc391b3e-b54d-4a4a-83cc-1f783afb23f9";
export const REDACTION_TYPE_ID = "fc2ca5fa-ec33-4dd2-9437-c570f1185a5d";
export const LINK_INSERTION_TYPE_ID = "1e478661-9a2a-4eb6-8334-bc670774e756";

// Translation key of each default type, custom types have none.
export const TRANSLATION_KEY_BY_DEFAULT_TYPE_ID = {
	[SPONSORED_TYPE_ID]: "sponsored",
	[REDACTION_TYPE_ID]: "redaction",
	[LINK_INSERTION_TYPE_ID]: "existing"
};
